var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.alert.show)?_c('v-alert',{staticClass:"login-alert text-center",attrs:{"dense":"","transition":"scale-transition","value":_vm.alert_timeout,"type":_vm.alert.status}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }